import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import AuditBrowser from '../../common/components/AuditBrowser';

const translationPrefix = 'kilowhat-audit.forum.modal.';

interface AuditModalAttrs extends IInternalModalAttrs {
    baseQ?: string
}

export default class AuditModal extends Modal<AuditModalAttrs> {
    className() {
        return 'AuditModal Modal--large';
    }

    title() {
        return app.translator.trans(translationPrefix + 'label');
    }

    content() {
        return m(
            '.Modal-body',
            m(
                '.Form',
                m(
                    '.AuditModal',
                    m(
                        '.AuditPageContainer',
                        m(AuditBrowser, { baseQ: this.attrs.baseQ })
                    )
                )
            )
        );
    }
}
